import React, { useState } from 'react'
import TabsComponent from '../../Components/Categories/TabsComponent/TabsComponent'
import Time from '../../Components/Time/Time'
import styles from '../../Components/Time/Time.module.css'
import SearchComponent from '../../Components/Utilities/SearchComponent';
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';





const TimePage = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { isEdit,servicesId, servicesId2, reservationNum } = location.state || {}; // Get card data from navigation state

  const [externalTab, setExternalTab] = useState(3);

  const isEditServisePreducer = JSON.parse(sessionStorage.getItem('isEditServisePreducer'));
  const cartFromCart = JSON.parse(sessionStorage.getItem('cartFromCart'));
  console.log("isEditServisePreducer",isEditServisePreducer, "cartFromCart", cartFromCart)
  
  const handleCardClick = (tabIndex) => {
    setExternalTab(tabIndex);
  };
  
  // Example options array


  return (
    <div className='flex-grow-1'>
       <div style={{ padding: '20px', maxWidth: '1000px', margin:"auto" }}>

      </div>
      {!isEdit && <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
   <TabsComponent externalTab={externalTab} setExternalTab={setExternalTab} isEditServisePreducer={isEditServisePreducer} />
      </div>}
    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}> {t('time')}</div>
    <div className={styles.loginSecHeader}>{t('select_available_times')}</div>


      </div>

      <Time  onCardClick={handleCardClick} servicesId={servicesId} isEdit={isEdit} servicesId2={servicesId2} reservationNum={reservationNum} isEditServisePreducer={isEditServisePreducer} cartFromCart={cartFromCart}/>
      
    </div>
  )
}
export default TimePage;
